import { SearchOptions, OpentionsNotFound } from "../../Translation";
import React, { useEffect, useState } from "react";

import { IconButton } from "@mui/material";
import { Mic } from "../../Icons";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import wordsToNumbers from "words-to-numbers";
import { toWords } from "number-to-words";
import Fuse from "fuse.js";
import { AudioToTextApi } from "../../Api";

const btnStyle = {
  backgroundColor: "white",
  border: "1px solid #f5e6f5",
  borderRadius: "50%",
  padding: "5px",
  margin: "3px",
};
const btnStyle1 = {
  backgroundColor: "#91278f",
  border: "1px solid #f5e6f5",
  borderRadius: "50%",
  padding: "5px",
  margin: "3px",
};
function SchemesOptions(props: any) {
  const [dropdownStyle, setDropDownStyle] = useState("dropDown");
  const [searchField, SetsearchField] = useState(false);
  const [blinking, setBlinking] = useState("");
  const [blinkBckGround, setBlinkBckGround] = useState(btnStyle);
  const { transcript: transcriptSearch, listening, resetTranscript } = useSpeechRecognition();

  // Audio recording refs for sending raw audio (iOS + browsers) to AudioToTextApi
  const mediaRecorderRef = React.useRef<MediaRecorder | null>(null);
  const mediaStreamRef = React.useRef<MediaStream | null>(null);
  const audioChunksRef = React.useRef<BlobPart[]>([]);
  const isRecordingRef = React.useRef(false);

  const {
    hideInput,
    selectedLanguage,
    optionList,
    setHideInput,
    setInputField,
    handleOptionClick,
    setBackOptions,
    optionHeader,
    searchTerm,
    setSearchTerm,
    recognitionSupported,
    pauseAudio,
    setVoiceRecognition,
    setRenderMic,
    renderMic,
    selectedServiceCategory,
    handleBackToServiceList,
    isPlaying,
  } = props;

  // Check if options are in service list format (have 'name' property) or regular format (have 'label' property)
  const isServiceListFormat = optionList && optionList.length > 0 && optionList[0].name !== undefined;

  const filteredStatesOptions =
    optionList &&
    optionList.length > 0 &&
    optionList.filter((val: any) => {
      if (isServiceListFormat) {
        // Service list format: use 'name' or 'en' for filtering
        const searchText = (val.name || val.en || "").toLowerCase();
        const searchTermLower = searchTerm.toLowerCase();

        // Convert number words to digits in both search term and text
        const searchTextConverted = wordsToNumbers(searchText);
        const searchTermConverted = wordsToNumbers(searchTermLower);

        // Check if converted versions match, or original match
        const searchTextStr = searchTextConverted !== null && searchTextConverted !== undefined
          ? searchTextConverted.toString()
          : searchText;
        const searchTermStr = searchTermConverted !== null && searchTermConverted !== undefined
          ? searchTermConverted.toString()
          : searchTermLower;

        return searchTextStr.includes(searchTermStr) || searchText.includes(searchTermLower);
      } else {
        // Regular format: use 'label' for filtering
        const labelText = val.label.toLowerCase();
        const searchTermLower = searchTerm.toLowerCase();

        // Convert number words to digits in both search term and label
        const labelTextConverted = wordsToNumbers(labelText);
        const searchTermConverted = wordsToNumbers(searchTermLower);

        // Check if converted versions match, or original match
        const labelTextStr = labelTextConverted !== null && labelTextConverted !== undefined
          ? labelTextConverted.toString()
          : labelText;
        const searchTermStr = searchTermConverted !== null && searchTermConverted !== undefined
          ? searchTermConverted.toString()
          : searchTermLower;

        return labelTextStr.includes(searchTermStr) || labelText.includes(searchTermLower);
      }
    });
  // Check if device is iOS/Mac (for recorder functionality)
  const isIOSDevice = () => {
    const platform = window.navigator.platform.toLowerCase();
    return platform.includes("mac") || platform.startsWith("ip");
  };

  // Check if we should use recorder for voice input
  // Now enabled for all platforms to allow testing AudioToTextApi
  const shouldUseRecorder = () => {
    // Currently enabled for all platforms (iOS + other browsers)
    return true;
  };

  // Convert recorded audio blob to base64 string
  const convertBlobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        const base64 = result.split(",")[1] || "";
        resolve(base64);
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(blob);
    });
  };

  // Start recording raw microphone audio (parallel to SpeechRecognition)
  const startAudioRecording = async () => {
    if (!shouldUseRecorder() || isRecordingRef.current) {
      return;
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);

      mediaStreamRef.current = stream;
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event: BlobEvent) => {
        if (event.data && event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.start();
      isRecordingRef.current = true;
    } catch (err) {
      console.error("Error starting audio recording:", err);
    }
  };

  // Stop recording and send audio to AudioToTextApi as base64
  const stopAudioRecordingAndSend = () => {
    if (!shouldUseRecorder() || !isRecordingRef.current) {
      return;
    }

    const mediaRecorder = mediaRecorderRef.current;
    if (!mediaRecorder) {
      return;
    }

    mediaRecorder.onstop = async () => {
      try {
        const chunks = audioChunksRef.current;
        audioChunksRef.current = [];

        if (!chunks.length) {
          console.warn("No audio chunks recorded.");
          return;
        }

        const blob = new Blob(chunks, { type: "audio/webm" });
        const base64 = await convertBlobToBase64(blob);

        if (!base64) {
          console.warn("Empty base64 audio payload.");
          return;
        }

        AudioToTextApi(base64, selectedLanguage, (response: any) => {
          console.log("🎧 AudioToTextApi raw response:", response);

          // Support multiple possible keys from backend: text, transcription, transcript
          const textFromApi: string =
            (response &&
              (response.text ||
                response.transcription ||
                response.transcript)) ||
            "";

          if (!textFromApi || !textFromApi.trim().length) {
            console.warn("AudioToTextApi returned empty text.");
            return;
          }

          // Use recognized text similarly to browser transcript
          const normalizedText = textFromApi.toLowerCase().trim();
          setSearchTerm(normalizedText);
          setInputField(true);
          setRenderMic(true);
          setBlinking("");
        });
      } catch (err) {
        console.error("Error processing recorded audio:", err);
      } finally {
        // Cleanup media stream
        if (mediaStreamRef.current) {
          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
          mediaStreamRef.current = null;
        }
        mediaRecorderRef.current = null;
        isRecordingRef.current = false;
      }
    };

    try {
      mediaRecorder.stop();
    } catch (err) {
      console.error("Error stopping MediaRecorder:", err);
    }
  };


  const requestPermission = async () => {
    try {
      startRecognition();
    } catch (error) {
      console.error("Permission denied:", error);
      alert("Error: " + error);
    }
  };

  const startRecognition = () => {
    console.log("🎤 ========== MIC CLICKED - START RECOGNITION ==========");
    console.log("🎤 Current transcript before reset:", transcriptSearch);
    console.log("🎤 Current hasTranscriptRef before reset:", hasTranscriptRef.current);

    setSearchTerm("");

    // CRITICAL: Reset transcript and flag to prevent stale data from triggering API
    resetTranscript();
    hasTranscriptRef.current = false;
    console.log("🔄 Transcript reset complete. New values:");
    console.log("   - transcriptSearch:", transcriptSearch);
    console.log("   - hasTranscriptRef:", hasTranscriptRef.current);

    setRenderMic(false);
    pauseAudio();
    // setVoiceRecognition(true);
    
    // iOS Safari only supports en-US for Web Speech API
    const speechRecLang = isIOSDevice() ? `en-US` : `${selectedLanguage}-IN`;
    SpeechRecognition.startListening({
      continuous: false,
      language: speechRecLang,
    });

    // Start raw audio recording as well (for iOS + browsers)
    if (shouldUseRecorder()) {
      startAudioRecording();
    }
    // setHideInput(false);
    setBlinking("blink");
    setBlinkBckGround(btnStyle1);
    console.log("🎤 ========== MIC SETUP COMPLETE ==========");
  };

  // Single handler for mic button: only starts recording when not already listening.
  // This prevents a second click (while mic is active) from stopping recording
  // and accidentally triggering the AudioToTextApi call.
  const handleMicClick = () => {
    if (listening) {
      console.log("🎤 Mic already active; ignoring click");
      return;
    }

    if (recognitionSupported) {
      startRecognition();
    } else {
      requestPermission();
    }
  };

  const stopRecognition = () => {
    console.log("🛑 stopRecognition called");
    // Stop browser SpeechRecognition (when available)
    SpeechRecognition.stopListening();

    // Hard‑reset the transcript so a stale script from a previous
    // session cannot leak into the next one (this showed up in
    // iOS logs where the old phrase seemed to persist).
    try {
      resetTranscript();
      hasTranscriptRef.current = false;
    } catch (err) {
      console.error(
        "Error while resetting transcript in SchemesOptions.stopRecognition:",
        err
      );
    }

    // Visual reset for mic animation
    setBlinking("");
    setBlinkBckGround(btnStyle);
    console.log(
      "🛑 Animation stopped - blinking cleared, background reset, transcript cleared"
    );
  };

  React.useEffect(() => {
    if (optionList && optionList.length < 5) {
      setDropDownStyle("dropDown_");
    } else {
      setDropDownStyle("dropDown");
    }

    // Always show search field with mic button when options are displayed
    if (optionList && optionList.length > 0) {
      SetsearchField(true);
    } else {
      SetsearchField(false);
    }
    setSearchTerm("");
    setBlinking("");
  }, [optionList]);

  // Track previous isPlaying state to detect when audio ends
  const prevIsPlayingRef = React.useRef<boolean | null>(null);

  React.useEffect(() => {
    // Only trigger mic when audio transitions from playing (true) to stopped (false)
    // This ensures mic doesn't start before audio even begins
    const wasPlaying = prevIsPlayingRef.current === true;
    const audioJustEnded = wasPlaying && !isPlaying;

    // Update the ref with current value
    prevIsPlayingRef.current = isPlaying;

    if (hideInput && audioJustEnded && optionList && optionList.length > 0) {
      const timer = setTimeout(() => {
        if (recognitionSupported) {
          startRecognition();
        } else {
          requestPermission();
        }
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [hideInput, isPlaying]);

  // Track if listening has actually started to avoid race conditions on startup
  const hasStartedListening = React.useRef(false);
  // Track if we got any transcript to avoid calling API on empty recordings
  const hasTranscriptRef = React.useRef(false);

  // Stop animation when mic stops listening (e.g., due to silence detection)
  React.useEffect(() => {
    console.log("👂 ========== LISTENING STATE CHANGED ==========");
    console.log("👂 listening:", listening);
    console.log("👂 blinking:", blinking);
    console.log("👂 hasTranscriptRef.current:", hasTranscriptRef.current);

    if (listening) {
      hasStartedListening.current = true;
      // Reset transcript flag when starting to listen
      hasTranscriptRef.current = false;
      console.log("✅ Listening STARTED - flag reset to false");

      // After a short delay, if we're still in listening state but
      // we have not received ANY transcript, log this explicitly so
      // we can debug "mic active but not capturing" scenarios.
      const noTranscriptTimer = setTimeout(() => {
        if (listening && !hasTranscriptRef.current) {
          console.log(
            "⚠️ [SchemesOptions] Mic is ACTIVE but no transcript has been captured yet.",
            {
              listening,
              blinking,
              hasTranscriptFlag: hasTranscriptRef.current,
              transcriptSearchSnapshot: transcriptSearch,
            }
          );
        }
      }, 2000);

      return () => clearTimeout(noTranscriptTimer);
    }

    // Only stop animation if we were listening and now we're not
    if (!listening && hasStartedListening.current) {
      console.log("🛑 ========== LISTENING STOPPED ==========");
      setBlinking("");
      setBlinkBckGround(btnStyle);
      hasStartedListening.current = false; // Reset for next time

      // When microphone stops (user silence or auto-stop), also stop
      // the raw audio recorder and send the captured audio as base64
      // to AudioToTextApi so this works on iOS devices and browsers.
      stopAudioRecordingAndSend();

      console.log("🛑 ========== LISTENING CLEANUP COMPLETE ==========");
      if (!hasTranscriptRef.current) {
        console.log(
          "⚠️ [SchemesOptions] Mic session ended WITHOUT any transcript being captured.",
          {
            listening,
            blinking,
            hasTranscriptFlag: hasTranscriptRef.current,
            lastTranscriptSearch: transcriptSearch,
          }
        );
      }
    } else if (!listening && blinking === "blink" && !hasStartedListening.current) {
      // Safety timeout: if we set blinking but listening never started after 2 seconds, kill it
      const safetyTimer = setTimeout(() => {
        if (blinking === "blink" && !listening) {
          console.log("⚠️ Safety timeout - mic never started listening, resetting animation");
          setBlinking("");
          setBlinkBckGround(btnStyle);
        }
      }, 2000);
      return () => clearTimeout(safetyTimer);
    }
  }, [listening, blinking]);

  // Helper function to normalize text by removing common words and extra spaces
  const normalizeText = (text: string): string => {
    const commonWords = ['a', 'an', 'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by'];
    return text
      .toLowerCase()
      .split(/\s+/)
      .filter(word => word.length > 0 && !commonWords.includes(word))
      .join(' ')
      .trim();
  };

  // Helper function to check if transcript matches option (fuzzy match)
  const findBestMatch = (transcript: string, options: any[], isServiceFormat: boolean) => {
    const transcriptLower = transcript.toLowerCase().trim();
    const transcriptNormalized = normalizeText(transcriptLower);

    // Prepare options for fuzzy matching
    const optionsForFuse = options.map((val: any) => {
      const displayText = isServiceFormat
        ? (val.name || val.en || "").toLowerCase()
        : val.label.toLowerCase();
      const normalizedText = normalizeText(displayText);
      return {
        ...val,
        searchText: displayText,
        normalizedText: normalizedText,
        originalText: displayText
      };
    });

    // First, try exact substring match (case-insensitive)
    const exactMatch = optionsForFuse.find((opt: any) =>
      opt.searchText.includes(transcriptLower) || transcriptLower.includes(opt.searchText)
    );
    if (exactMatch) {
      return { item: exactMatch, score: 0 };
    }

    // Try normalized text match (without common words)
    const normalizedMatch = optionsForFuse.find((opt: any) =>
      opt.normalizedText.includes(transcriptNormalized) ||
      transcriptNormalized.includes(opt.normalizedText) ||
      opt.normalizedText === transcriptNormalized
    );
    if (normalizedMatch) {
      return { item: normalizedMatch, score: 0.1 };
    }

    // Use Fuse.js for fuzzy matching with more lenient threshold
    const fuseOptions = {
      keys: ['searchText', 'normalizedText'],
      threshold: 0.6, // More lenient threshold (0.0 = exact, 1.0 = match anything)
      includeScore: true,
      minMatchCharLength: 2,
      ignoreLocation: true, // Don't care about word position
      findAllMatches: false
    };

    const fuse = new Fuse(optionsForFuse, fuseOptions);
    const results = fuse.search(transcriptLower);

    // Also try searching with normalized text
    if (results.length === 0 || (results[0].score && results[0].score > 0.5)) {
      const normalizedResults = fuse.search(transcriptNormalized);
      if (normalizedResults.length > 0 && normalizedResults[0].score !== undefined) {
        return normalizedResults[0];
      }
    }

    return results.length > 0 ? results[0] : null;
  };

  React.useEffect(() => {
    // When using raw audio recorder + AudioToTextApi (current behavior for all platforms),
    // we ignore the browser's SpeechRecognition transcript and rely ONLY on the
    // text returned from AudioToTextApi (set in stopAudioRecordingAndSend).
    if (shouldUseRecorder()) {
      return;
    }

    console.log("📋 ========== TRANSCRIPT EFFECT TRIGGERED ==========");
    console.log("📋 transcriptSearch value:", `"${transcriptSearch}"`);
    console.log("📋 transcriptSearch length:", transcriptSearch?.length || 0);
    console.log("📋 transcriptSearch trimmed length:", transcriptSearch?.trim().length || 0);
    console.log("📋 Current hasTranscriptRef:", hasTranscriptRef.current);

    // Mark that we have a transcript (for both browsers and iOS)
    if (transcriptSearch && transcriptSearch.trim().length > 0) {
      console.log("✅✅✅ SETTING TRANSCRIPT FLAG TO TRUE ✅✅✅");
      console.log("📝 Transcript detected, setting flag:", transcriptSearch.trim());
      hasTranscriptRef.current = true;
    } else {
      console.log("⏸️ No valid transcript - flag remains:", hasTranscriptRef.current);
    }
    console.log("📋 Final hasTranscriptRef:", hasTranscriptRef.current);
    console.log("📋 ========== TRANSCRIPT EFFECT COMPLETE ==========");

    const delayDebounceFn = setTimeout(() => {
      if (transcriptSearch && !renderMic && optionList && optionList.length > 0) {
        // Check if options are in service list format (compute inside useEffect)
        const isServiceFormat = optionList && optionList.length > 0 && optionList[0].name !== undefined;

        // Find best match using improved fuzzy matching
        const matchResult = findBestMatch(transcriptSearch, optionList, isServiceFormat);

        // If we found a good match (score < 0.6 means good match)
        if (matchResult && matchResult.item && matchResult.score !== undefined && matchResult.score < 0.6) {
          // Get the display text of the best matching option
          const bestMatch = matchResult.item;
          const displayText = isServiceFormat
            ? (bestMatch.name || bestMatch.en || "")
            : bestMatch.label;

          // Set search term to show the nearest match (don't call API directly)
          stopRecognition();
          setRenderMic(true);
          setSearchTerm(displayText.toLowerCase());
          setBlinking("");
          setInputField(true);
        } else {
          // No good match found, just filter options with the transcript
          setSearchTerm(transcriptSearch.toLowerCase().trim());
          stopRecognition();
          setInputField(true);
        }
      } else if (transcriptSearch && !renderMic) {
        // Fallback: just set search term if no options available
        setSearchTerm(transcriptSearch);
        stopRecognition();
        setInputField(true);
      }
    }, 500);
    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [transcriptSearch, optionList, renderMic]);

  return (
    <React.Fragment>
      {hideInput && (
        <div className={dropdownStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
            {selectedServiceCategory && handleBackToServiceList ? (
              <span
                onClick={() => {
                  // Stop speech recognition and audio recording if active
                  if (listening || !renderMic) {
                    SpeechRecognition.stopListening();
                    // Stop audio recorder if running
                    if (isRecordingRef.current && mediaRecorderRef.current) {
                      try {
                        mediaRecorderRef.current.stop();
                        if (mediaStreamRef.current) {
                          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
                        }
                      } catch (err) {
                        console.error("Error stopping recorder on back:", err);
                      }
                    }
                    isRecordingRef.current = false;
                  }
                  
                  // Reset mic-related states
                  setBlinking("");
                  setBlinkBckGround(btnStyle);
                  setRenderMic(true);
                  setSearchTerm("");
                  
                  handleBackToServiceList();
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#000000",
                  fontWeight: "500",
                  padding: "4px 8px",
                  display: "flex",
                  alignItems: "center"
                }}
                title="Back to services"
              >
                ← Back
              </span>
            ) : <div></div>}
            <div className="closeIcon">
              <img
                src="close.png"
                width={15}
                height={15}
                alt="close"
                className="close"
                onClick={() => {
                  // Stop speech recognition and audio recording if active
                  if (listening || !renderMic) {
                    SpeechRecognition.stopListening();
                    // Stop audio recorder if running
                    if (isRecordingRef.current && mediaRecorderRef.current) {
                      try {
                        mediaRecorderRef.current.stop();
                        if (mediaStreamRef.current) {
                          mediaStreamRef.current.getTracks().forEach((track) => track.stop());
                        }
                      } catch (err) {
                        console.error("Error stopping recorder on close:", err);
                      }
                    }
                    isRecordingRef.current = false;
                  }
                  
                  // Reset all mic-related states
                  setBlinking("");
                  setBlinkBckGround(btnStyle);
                  setRenderMic(true);
                  setSearchTerm("");
                  
                  // Reset component states
                  setHideInput(false);
                  setInputField(false);
                  setBackOptions(true);
                  
                  // Reset to main service list if viewing subcategories
                  if (handleBackToServiceList && selectedServiceCategory) {
                    handleBackToServiceList();
                  }
                }}
              />
            </div>
          </div>
          <span className="optionHeader">
            {selectedServiceCategory
              ? (selectedServiceCategory.name || selectedServiceCategory.en || optionHeader)
              : optionHeader}
          </span>
          {searchField && (
            <div className="BoxSentMSGSchemes">
              <>
                <input
                  className="inputSchemes"
                  type="text"
                  placeholder={(SearchOptions as any)[selectedLanguage]}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <IconButton
                  size="small"
                  style={blinkBckGround}
                  className={blinking ? "micBtnActive" : ""}
                  onClick={handleMicClick}
                >
                  <span className={blinking}> {Mic}</span>
                </IconButton>
              </>
            </div>
          )}

          <div style={{ overflowY: "scroll", height: "100%" }}>
            {filteredStatesOptions && filteredStatesOptions.length > 0 ? (
              filteredStatesOptions.map((val: any, index: number) => {
                // Determine display text based on format
                const displayText = isServiceListFormat
                  ? (val.name || val.en || "")
                  : val.label;

                // Determine id/value for the element
                const elementId = isServiceListFormat
                  ? (val.id || val.name || "")
                  : (val.value || "");

                return (
                  <div
                    className="optionContainer"
                    key={index}
                    style={isServiceListFormat && val.iconUrl ? { display: "flex", alignItems: "center" } : {}}
                  >
                    {isServiceListFormat && val.iconUrl && (
                      <img
                        src={val.iconUrl}
                        alt={displayText}
                        style={{ width: "24px", height: "24px", marginRight: "8px", flexShrink: 0 }}
                      />
                    )}
                    <p
                      className="optionItem"
                      id={elementId}
                      onClick={() => handleOptionClick(val)}
                      style={{ margin: 0, flex: 1 }}
                    >
                      {displayText.toUpperCase()}
                    </p>
                  </div>
                );
              })
            ) : (
              <span>
                <div className="optionContainer">
                  <p className="optionItem">
                    {(OpentionsNotFound as any)[selectedLanguage]}
                  </p>
                </div>
              </span>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default SchemesOptions;
